import React, { Fragment } from "react";
import spinner from "./spinner.gif";

export default function Spinner() {
  return (
    <Fragment>
      <img src={spinner} alt="...loading" style={{ width: "60px" }}></img>
    </Fragment>
  );
}
